/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * API For public part of application: Inzerce movitého majetku
 * This API provides endpoints for public part: Inzerce movitého majetku
 * OpenAPI spec version: v1
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";

import type { AssetAttributeList } from "../aPIForPublicPartOfApplicationInzerceMovitéhoMajetku.schemas";

import { restAxiosFetcher } from "../../restAxiosFetcher";
import type { ErrorType } from "../../restAxiosFetcher";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieves a list of all available asset attributes.
 */
export const getApiAssetscategoryattributesList = (
	options?: SecondParameter<typeof restAxiosFetcher>,
	signal?: AbortSignal,
) => {
	return restAxiosFetcher<AssetAttributeList>(
		{ url: `/api/assetscategoryattributes/list`, method: "GET", signal },
		options,
	);
};

export const getGetApiAssetscategoryattributesListQueryKey = () => {
	return [`/api/assetscategoryattributes/list`] as const;
};

export const getGetApiAssetscategoryattributesListQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>>;
	request?: SecondParameter<typeof restAxiosFetcher>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetscategoryattributesListQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>> = ({ signal }) =>
		getApiAssetscategoryattributesList(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetscategoryattributesListQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>
>;
export type GetApiAssetscategoryattributesListQueryError = ErrorType<unknown>;

export function useGetApiAssetscategoryattributesList<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetscategoryattributesList<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetscategoryattributesList<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a list of all available asset attributes.
 */

export function useGetApiAssetscategoryattributesList<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetscategoryattributesListQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves a list of all available asset attributes.
 */
export const prefetchGetApiAssetscategoryattributesListQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	queryClient: QueryClient,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetscategoryattributesListQueryOptions(options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetscategoryattributesListSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>
	>;
	request?: SecondParameter<typeof restAxiosFetcher>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetscategoryattributesListQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>> = ({ signal }) =>
		getApiAssetscategoryattributesList(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetscategoryattributesListSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>
>;
export type GetApiAssetscategoryattributesListSuspenseQueryError = ErrorType<unknown>;

export function useGetApiAssetscategoryattributesListSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetscategoryattributesListSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetscategoryattributesListSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a list of all available asset attributes.
 */

export function useGetApiAssetscategoryattributesListSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetscategoryattributesList>>, TError, TData>
		>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetscategoryattributesListSuspenseQueryOptions(options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}
